import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CGU = () => {
  return (
    <div className="min-h-screen bg-[#030303]">
      {/* Header */}
      <div className="border-b border-[#1C1C1C]">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#71717A] hover:text-[#A1A1AA] transition-colors text-sm"
          >
            <ArrowLeft size={16} />
            Retour
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <header className="mb-16 text-center">
          <h1 
            className="text-3xl md:text-4xl text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-[#D4AF37] text-sm tracking-[0.2em] uppercase">
            Clierxter Vision Lab
          </p>
        </header>

        <div className="space-y-12 text-[#A1A1AA] leading-relaxed">
          
          {/* Section 1 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Objet
            </h2>
            <p>
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités d'accès et d'utilisation de la plateforme Clierxter Vision Lab.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Accès à la plateforme
            </h2>
            <p className="mb-4">
              La plateforme est accessible via internet aux utilisatrices disposant d'un compte actif.
            </p>
            <p>
              L'accès peut être suspendu temporairement pour maintenance ou mise à jour.
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Création de compte
            </h2>
            <p className="mb-4">
              L'utilisatrice doit fournir des informations exactes lors de son inscription.
            </p>
            <p>
              Elle est responsable de la confidentialité de ses identifiants.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Utilisation des services
            </h2>
            <p className="mb-4">
              L'utilisatrice s'engage à utiliser les outils et contenus de manière responsable.
            </p>
            <p>
              Elle reconnaît que la plateforme fournit des outils d'aide et non des résultats garantis.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Comportement
            </h2>
            <p className="mb-4">
              Il est interdit de :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>publier des contenus offensants ou illégaux</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>harceler d'autres membres</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>détourner la plateforme de son usage initial</span>
              </li>
            </ul>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Communauté
            </h2>
            <p className="mb-4">
              La plateforme propose un espace d'échange entre utilisatrices.
            </p>
            <p>
              Clierxter Vision Lab se réserve le droit de modérer ou supprimer tout contenu inapproprié.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              7. Suspension / Résiliation
            </h2>
            <p>
              Clierxter Vision Lab peut suspendre ou supprimer un compte en cas de non-respect des présentes CGU.
            </p>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              8. Responsabilité
            </h2>
            <p>
              Clierxter Vision Lab ne peut être tenu responsable des décisions prises par l'utilisatrice suite à l'utilisation des outils.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              9. Propriété intellectuelle
            </h2>
            <p>
              Tous les contenus sont protégés et ne peuvent être copiés ou utilisés sans autorisation.
            </p>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              10. Modification des CGU
            </h2>
            <p>
              Les CGU peuvent être modifiées à tout moment.
            </p>
          </section>

          {/* Section 11 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              11. Droit applicable
            </h2>
            <p>
              Les présentes CGU sont régies par le droit suisse.
            </p>
          </section>

          {/* Section 12 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              12. Protection des données
            </h2>
            <p className="mb-4">
              Les données personnelles collectées sont traitées conformément à notre politique de confidentialité.
            </p>
            <p>
              L'utilisatrice peut demander l'accès, la modification ou la suppression de ses données à tout moment.
            </p>
          </section>

          {/* Section 13 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              13. Évolution de la plateforme
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab est une plateforme vivante qui évoluera continuellement.
            </p>
            <p className="mb-4">
              De nouvelles fonctionnalités, outils, capacités IA, ressources éducatives et améliorations peuvent être ajoutés au fil du temps.
            </p>
            <p className="mb-4">
              Certaines nouvelles fonctionnalités peuvent être disponibles pour tous les membres, tandis que d'autres peuvent être réservées aux abonnées Vision Lab Experience.
            </p>
            <p>
              La plateforme se réserve le droit d'améliorer, modifier ou discontinuer des fonctionnalités afin de fournir la meilleure expérience possible.
            </p>
          </section>

          {/* Section 14 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              14. Avertissement IA
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab utilise l'intelligence artificielle pour fournir des conseils, suggestions et un accompagnement éducatif.
            </p>
            <p className="mb-4">
              Le contenu généré par l'IA est destiné à assister les utilisatrices et ne doit pas être considéré comme un conseil juridique, financier, médical ou professionnel.
            </p>
            <p>
              Les utilisatrices restent responsables de toutes les décisions commerciales et actions entreprises sur la base des informations fournies par la plateforme.
            </p>
          </section>

        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-[#1C1C1C] text-center">
          <p className="text-[#52525B] text-sm">
            Clierxter Vision Lab
          </p>
        </footer>
      </div>
    </div>
  );
};

export default CGU;
